import Swiper, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

/* Success Values Slider */

window.addEventListener("load", function () {
	function valuesSlider() {
		const valuesSlider = new Swiper("#valuesSlider", {
			modules: [Navigation],
			direction: "horizontal",
			slidesPerView: 1.4,
			spaceBetween: 15,

			navigation: {
				nextEl: ".nav-mobile #nextBtnMobile",
				prevEl: ".nav-mobile #prevBtnMobile",
			},

			breakpoints: {
				750: {
					slidesPerView: 2.4,
					spaceBetween: 20,
				},
				1340: {
					slidesPerView: 3.2,
					spaceBetween: 20,
					navigation: {
						nextEl: ".nav-desktop #nextBtnDesktop",
						prevEl: ".nav-desktop #prevBtnDesktop",
					},
				},
				1920: {
					slidesPerView: 3.6,
					spaceBetween: 20,
					navigation: {
						nextEl: ".nav-desktop #nextBtnDesktop",
						prevEl: ".nav-desktop #prevBtnDesktop",
					},
				},
			},
		});
	}
	valuesSlider();
	window.addEventListener("resize", valuesSlider);
});
